module.exports = __webpack_public_path__ + "img/TechArmorWall2_ua.a8929eee.webp";